import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import Scene = Phaser.Scene;
import {Creature} from "@/store/level/types";
import {CreaturePanelWithCheck} from "@/scenes.ui/creature-panel-with-check";
import {CreaturePrice} from "@/store/shop/types";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import CreaturePanel from "@/scenes.ui/creature-panel";

export class SellCreaturesNavPanel extends AbstractNavPanel {

    private checkedIds: Set<number> = new Set<number>();

    private changeCallback: (sumDecrease: number, checkedIds: Set<number>) => unknown;

    private static priceById: Map<number, number>;

    protected creaturePanels!: CreaturePanelWithCheck[];

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, creatures: Creature[],
                changeCallback: (sumDecrease: number, checkedIds: Set<number>) => unknown) {
        super(scene, canvas, x, y, creatures, 4);
        this.changeCallback = changeCallback;

        SpriteUtils.scale(this, 0.7 / CU.S);
    }

    public getCheckedIds(): Set<number> {
        return this.checkedIds;
    }

    public static setupPrices(prices: CreaturePrice[]) {
        for (let p of prices) {
            SellCreaturesNavPanel.getPriceByIdMap().set(p.creatureId, p.price);
        }
    }

    protected makePanel(x: number, element: any): any {
        let self = this;
        let cr = <Creature>element;

        let price = SellCreaturesNavPanel.getPriceByIdMap().has(cr.id) ? SellCreaturesNavPanel.getPriceByIdMap().get(cr.id) : 0;
        let creaturePanel = new CreaturePanelWithCheck(this.scene!, x * CU.S, 10, cr, price!, self.selectSound,
            () => undefined, (checked: boolean) => {
                self.checkCallback(cr, checked);
            }, true);
        creaturePanel.setHealthVisible();
        creaturePanel.setDepth(1000);
        if(!this.creaturePanels) {
            this.creaturePanels = [];
        }
        this.creaturePanels.push(creaturePanel);
        this.actualizePanel(creaturePanel);
        return creaturePanel;

    }

    public actualizePanels() {
        this.creaturePanels.forEach((cp) => {
           this.actualizePanel(cp);
        });
    }

    private actualizePanel(cp: CreaturePanelWithCheck) {
        if(!this.checkedIds){
            return;
        }

        if(this.checkedIds.has(cp.getCreature().id) && !cp.isChecked()) {
            cp.setChecked(true);
        } else if (!this.checkedIds.has(cp.getCreature().id) && cp.isChecked()) {
            cp.setChecked(false);
        }
    }

    public checkCallback(cr:Creature, checked: boolean) {
        let self = this;
        if (checked) {
            self.checkedIds.add(cr.id);
        } else {
            self.checkedIds.delete(cr.id);
        }
        self.changeCallback(self.getSumDecrease(), self.checkedIds);
    }

    protected getButtonX(): number {
        return 280;
    }

    protected getButtonY(): number {
        return 10;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        return creaturesAmount === 2 ? 180 : 130;
    }

    public static getPriceByIdMap() {
        if (!SellCreaturesNavPanel.priceById) {
            SellCreaturesNavPanel.priceById = new Map<number, number>();
        }
        return SellCreaturesNavPanel.priceById;
    }

    public getSumDecrease() : number {
        let price = 0;
        for (let id of this.checkedIds) {
            if (SellCreaturesNavPanel.priceById && SellCreaturesNavPanel.priceById.has(id)) {
                price += SellCreaturesNavPanel.getPriceByIdMap().get(id)!;
            }
        }
        return price;
    }
}
